<script>
import validations from './helpers/validations';
import FormInput from 'v3/components/Form/Input.vue';
import { reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';

import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
    FormInput,
  },
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
    submitInProgress: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {},
    },
    submitButtonText: {
      type: String,
      default: '',
    },
    submitActionsClass: {
      type: String,
      default: 'flex flex-row justify-end gap-2 py-2 px-0 w-full',
    },
    submitButtonWrapperClass: {
      type: String,
      default: 'w-full',
    },
    submitButtonClass: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const formData = props.formData || {};
    const {
      description = '',
      name: title = '',
      allow_auto_assign: allowAutoAssign = true,
    } = formData;

    const state = reactive({
      description,
      title,
      allowAutoAssign,
    });

    const rules = validations;
    const v$ = useVuelidate(rules, state);
    return { state, v$ };
  },
  methods: {
    handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.onSubmit({
        description: this.state.description,
        name: this.state.title,
        allow_auto_assign: this.state.allowAutoAssign,
      });
    },
  },
};
</script>

<template>
  <div class="flex-shrink-0 w-full">
    <form class="mx-0 grid gap-4" @submit.prevent="handleSubmit">
      <FormInput
        v-model="state.title"
        name="title"
        spacing="compact"
        :label="$t('TEAMS_SETTINGS.FORM.NAME.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.NAME.PLACEHOLDER')"
        :has-error="v$.title.$error"
        :error-message="v$.title.$error ? v$.title.$errors[0].$message : ''"
        @blur="v$.title.$touch"
      />
      <FormInput
        v-model="state.description"
        name="description"
        spacing="compact"
        :label="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.PLACEHOLDER')"
        :has-error="v$.description.$error"
        :error-message="
          v$.description.$error ? v$.description.$errors[0].$message : ''
        "
        @blur="v$.description.$touch"
      />
      <label
        for="team-auto-assignment"
        class="flex w-full cursor-pointer items-start gap-3 rounded-[8px] border border-n-weak bg-[#fbfcfd] p-4"
      >
        <input
          id="team-auto-assignment"
          v-model="state.allowAutoAssign"
          type="checkbox"
          :value="true"
          class="mt-0.5 size-4 flex-shrink-0 accent-[#dc2626]"
        />
        <span class="min-w-0">
          <span class="block text-sm font-medium text-n-slate-12">
            {{ $t('TEAMS_SETTINGS.FORM.AUTO_ASSIGN.LABEL') }}
          </span>
          <span class="mt-1 block text-sm leading-5 text-n-slate-11">
            {{ $t('TEAMS_SETTINGS.FORM.AUTO_ASSIGN.DESCRIPTION') }}
          </span>
        </span>
      </label>
      <slot name="extra-fields" />
      <div :class="submitActionsClass">
        <div :class="submitButtonWrapperClass">
          <NextButton
            type="submit"
            :label="submitButtonText"
            :class="submitButtonClass"
            :disabled="v$.title.$invalid || submitInProgress"
            :is-loading="submitInProgress"
          />
        </div>
      </div>
    </form>
  </div>
</template>
